var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('div',{staticClass:"indicators"},_vm._l((_vm.value),function(v,i){return _c('div',{key:i,class:['indicator', `indicator--${v}`]},[_vm._v(_vm._s(_vm.value))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }